import { Component } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldConfig } from "../../interface/field.interface";

@Component({
    selector: 'form-field-date-picker',
    templateUrl: './eipdatepicker.component.html'
})
export class EipDatePickerComponent {
    field!: FieldConfig;
    group!: FormGroup;
    formName:string = '';
    constructor() { }
    getWaterMark(): string | undefined {
        return this.field.label;
    }

    getId():string{
        return this.formName+this.field.name;
    }

    getSelectedDate(value: any) {
        if(this.field.name)
        this.group.get(this.field.name)?.setValue(value);
    }
}